<template>
  <div>
    <a-page-header :ghost="false">
      <template #extra>
        <a-button type="primary" icon="plus" @click="() => operation = OPERATION_CREATE">New Sponsor</a-button>
      </template>
    </a-page-header>

    <h-sponsor-list/>

    <a-drawer :width="720" placement="right" :closable="true" :visible="operation !== null" @close="() => operation = null">
      <template v-if="operation === OPERATION_CREATE">
        <h-sponsor-form :sponsor="null" @success="() => operation = null" />
      </template>
    </a-drawer>
  </div>
</template>

<script>
const operations = {
  OPERATION_CREATE: 'create'
}

export default {
  data: () => ({
    ...operations,
    operation: null
  })
}
</script>
